export const GET_MOCKUPTEST = "GET_MOCKUPTEST"
export const GET_MOCKUPTEST_SUCCESS = "GET_MOCKUPTEST_SUCCESS"
export const ADD_NEW_MOCKUPTEST = "ADD_NEW_MOCKUPTEST"
export const ADD_NEW_MOCKUPTEST_SUCCESS = "ADD_NEW_MOCKUPTEST_SUCCESS"
export const EDITLOAD_MOCKUPTEST = "EDITLOAD_MOCKUPTEST"
export const EDITLOAD_MOCKUPTEST_SUCCESS = "EDITLOAD_MOCKUPTEST_SUCCESS"
export const DELETE_MOCKUPTEST = "DELETE_MOCKUPTEST"
export const DELETE_MOCKUPTEST_SUCCESS = "DELETE_MOCKUPTEST_SUCCESS"
export const RESET_STORE_MOCKUPTEST = "RESET_STORE_MOCKUPTEST"
